import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { colors, breakpoints } from '../../../assets/styles/GlobalStyles';

const InputContainer = styled.div`
  width: 100%;
  margin-bottom: ${props => props.$noMargin ? '0' : '1.2rem'};
  position: relative;
`;

const Label = styled.label`
  display: block;
  margin-bottom: 0.5rem;
  color: ${colors.darkBlue};
  font-weight: 600;
  font-size: 0.9rem;

  span {
    color: #ff4444;
  }

  @media (max-width: ${breakpoints.mobile}) {
    font-size: 0.85rem;
  }
`;

const StyledInput = styled.input`
  width: 100%;
  padding: ${props => props.$hasIcon ? '0.9rem 2.5rem 0.9rem 0.9rem' : '0.9rem'};

  border: 2px solid ${props => {
    if (props.$hasError) return '#ff4444';
    if (props.$success) return '#4CAF50';
    return '#e8ecef';
  }};

  border-radius: 8px;
  font-size: 0.95rem;
  transition: all 0.3s ease;
  box-sizing: border-box;
  background: ${props => props.disabled ? '#f5f5f5' : colors.backgroundLight};

  &:focus {
    outline: none;
    border-color: ${props => {
      if (props.$hasError) return '#ff4444';
      if (props.$success) return '#4CAF50';
      return colors.lightBlue;
    }};
    background: white;
  }

  // 16px evita o zoom automático do Safari/iOS ao focar o campo.
  @media (max-width: ${breakpoints.mobile}) {
    padding: ${props => props.$hasIcon ? '0.8rem 2.5rem 0.8rem 0.8rem' : '0.8rem'};
    font-size: 16px;
  }
`;

const IconWrapper = styled.div`
  position: absolute;
  right: 0.8rem;
  top: 50%;
  transform: translateY(-50%);
  color: #666;
  display: flex;
  align-items: center;
  z-index: 2;
`;

const ErrorMessage = styled.small`
  color: #ff4444;
  font-size: 0.8rem;
  margin-top: 0.3rem;
  display: block;
`;

const SuccessMessage = styled.small`
  color: #4CAF50;
  font-size: 0.8rem;
  margin-top: 0.3rem;
  display: block;
`;

const HelperText = styled.small`
  color: #666;
  font-size: 0.8rem;
  margin-top: 0.3rem;
  display: block;
`;

export const Input = forwardRef(({
  label,
  error,
  success,
  helper,
  icon,
  required,
  noMargin,
  id,
  ...props
}, ref) => {
  const inputId = id || `input-${Math.random().toString(36).substr(2, 9)}`;

  return (
    <InputContainer $noMargin={noMargin}>
      {label && (
        <Label htmlFor={inputId}>
          {label} {required && <span>*</span>}
        </Label>
      )}

      <div style={{ position: 'relative' }}>
        <StyledInput
          ref={ref}
          id={inputId}
          $hasError={!!error}
          $success={!!success}
          $hasIcon={!!icon}
          {...props}
        />
        {icon && <IconWrapper>{icon}</IconWrapper>}
      </div>

      {/* Mensagens de feedback - apenas uma aparece por vez: error > success > helper */}
      {error && <ErrorMessage>{error}</ErrorMessage>}
      {success && !error && <SuccessMessage>{success}</SuccessMessage>}
      {helper && !error && !success && <HelperText>{helper}</HelperText>}
    </InputContainer>
  );
});
